import React from 'react';
import { Fragment } from 'react';
import { Typography, Box } from '@mui/material';
import { ButtonLink, ButtonColor, ButtonVariant } from '../Button';
import TeachersLeadForm from './TeachersLeadForm';
import './TeachersLanding.css';

const TeachersLanding = () => {
  return (
    <Fragment>
      <div className="teachers-landing">
        <Box
          sx={{
            'background-color': 'var(--blue-300)',
            justifyContent: 'center',
            display: 'flex',
            padding: { xs: '2rem 0', sm: '3rem 0' }
          }}>
          <div className="teachers-landing-container">
            <div className="teachers-landing-content">
              <div className="teachers-landing-title">
                <h1>¿Querés ser profe en Estudi?</h1>
                <h2>Enseñá lo que ya sabés y generá ingresos extras</h2>
              </div>
              <p className="teachers-landing-subtitle">
                Conectate con estudiantes que necesitan tu ayuda y compartí tu conocimiento mientras
                ganás dinero dando clases particulares.
              </p>
            </div>
          </div>
        </Box>

        <div className="teachers-benefits-section">
          <Typography
            variant="h3"
            sx={{
              color: 'var(--blue-600)',
              textAlign: 'center',
              marginBottom: { xs: '2rem', sm: '3rem' },
              fontSize: { xs: '1.5rem', sm: '2rem' },
              fontWeight: 600
            }}>
            ¿Por qué dar clases en Estudi?
          </Typography>

          <div className="teachers-benefits-grid">
            <div className="benefit-item">
              <div className="benefit-icon">👥</div>
              <h3>Alumnos para alumnos</h3>
              <p>
                Conectá directamente con estudiantes universitarios que buscan apoyo en las materias
                que dominás. Una plataforma diseñada específicamente para vos.
              </p>
            </div>

            <div className="benefit-item">
              <div className="benefit-icon">📚</div>
              <h3>Dominio de los temas y responsabilidad</h3>
              <p>
                Enseñá las materias que ya conocés y manejás. Tu experiencia como estudiante
                avanzado es tu mejor herramienta para ayudar a otros.
              </p>
            </div>

            <div className="benefit-item">
              <div className="benefit-icon">📅</div>
              <h3>Calendario propio</h3>
              <p>
                Gestioná tu disponibilidad con tu propio calendario. Mantené tu agenda actualizada
                para que los alumnos puedan reservar clases cuando estés disponible.
              </p>
            </div>

            <div className="benefit-item">
              <div className="benefit-icon">💳</div>
              <h3>Pagos con MercadoPago</h3>
              <p>
                Recibí tus pagos de forma segura y rápida a través de MercadoPago. Sin
                complicaciones, sin demoras.
              </p>
            </div>

            <div className="benefit-item">
              <div className="benefit-icon">💬</div>
              <h3>Grupo para chatear</h3>
              <p>
                Comunicate directamente con tus alumnos a través de un grupo de chat dedicado.
                Resolvé dudas y coordiná clases de manera sencilla.
              </p>
            </div>
          </div>
        </div>

        <div className="teachers-form-section">
          <Typography
            variant="h4"
            sx={{
              color: 'var(--blue-600)',
              textAlign: 'center',
              marginBottom: '1rem',
              fontSize: { xs: '1.25rem', sm: '1.5rem' },
              fontWeight: 600
            }}>
            ¿Tenés dudas o querés saber más sobre dar clases en Estudi?
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: 'var(--gray-500)',
              textAlign: 'center',
              marginBottom: '2rem',
              fontSize: { xs: '0.9rem', sm: '1rem' },
              padding: { xs: '0 1rem', sm: '0' }
            }}>
            Dejanos tus datos y te contactamos
          </Typography>

          <TeachersLeadForm />

          <div className="teachers-register-button-container">
            <ButtonLink
              variant={ButtonVariant.OUTLINED}
              color={ButtonColor.SECONDARY}
              className="teachers-register-button"
              href="https://teachers.estudi.com.ar/"
              target="_blank"
              rel="noopener noreferrer">
              No tengo dudas, quiero sumarme ya
            </ButtonLink>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default TeachersLanding;
